angular
  .module('tgaApp', [
    'environment',
    'LocalStorageModule',
    'ui.router',
    'ui.bootstrap',
    'countUpModule',
    'ngAnimate',
    'ngSanitize',
    'timer',
    'chart.js',
    'pascalprecht.translate',
  ])
  .controller('AppController', [
    '$scope',
    '$rootScope',
    '$window',
    '$state',
    '$location',
    '$uibModalStack',
    'scormService',
    'analyticsService',
    '$translate',
    'utilityService',
    '$timeout',
    function (
      $scope,
      $rootScope,
      $window,
      $state,
      $location,
      $uibModalStack,
      scormService,
      analyticsService,
      $translate,
      utilityService,
      $timeout,
    ) {
      $scope.state = $state;
      $translate.use('en_us');

      $rootScope.game_id = $location.search().game_id || null;
      $rootScope.username = $location.search().username || null;
      $rootScope.slug = $location.path() ? $location.path().substring(1) : null;
      $rootScope.token = $location.search().token || null;

      $scope.detectMobile = function () {
        return utilityService.isMobile();
      };

      this.maintainRatio = () => {
        const ratio = 16 / 9;
        const width = 1920;
        const height = 1080;
        const w = angular.element($window);
        const currentRatio = w.width() / w.height();
        const scale = ratio > currentRatio ? w.width() / width : w.height() / height;
        angular.element('.gameContainer').css({
          transform: `${'translate(-50%, 0%) scale('}${scale})`,
        });
        angular.element('.loading-indicator-wrapper').css({
          transform: `${'translate(-50%, 0%) scale('}${scale})`,
        });
        $scope.$broadcast('resize-scale', { scale });
      };

      this.initialize = () => {
        const stateChangeStart = $rootScope.$on('$stateChangeStart', (e) => {
          if ($uibModalStack.getTop()) {
            if ($uibModalStack.getTop().value.backdrop !== 'static') {
              $uibModalStack.dismissAll();
            }
            e.preventDefault();
          }
        });

        const viewContentLoaded = $rootScope.$on('$viewContentLoaded', () => {
          this.maintainRatio();
        });

        const stateChangeSuccess = $rootScope.$on('$stateChangeSuccess', (event, toState) => {
          $window.document.title = toState.data.title;
        });

        if (!utilityService.isMobile()) {
          $window.addEventListener('resize', this.maintainRatio);
        } else {
          $window.addEventListener('orientationchange', () => {
            $timeout(() => {
              this.maintainRatio();
            }, 400);
          });
        }
        $timeout(() => {
          this.maintainRatio();
        });

        $scope.$on('check-ratio', () => {
          this.maintainRatio();
        });

        $scope.$on('$destroy', () => {
          viewContentLoaded();
          stateChangeSuccess();
          stateChangeStart();
        });

        scormService.init();
      };

      this.initialize();
    },
  ]);

// Prevent back button
// eslint-disable-next-line angular/window-service, no-undef
window.onpopstate = function () {
  // eslint-disable-next-line angular/window-service, no-undef
  window.history.forward(1);
};
